import React from 'react';
import PropTypes from 'prop-types';
import LazyCell from './LazyCell';
import FolioCell from '../FolioCell';
import mergeInvoiceDocumentFinanceState from '../../../helpers/merge-invoice-document-finance-state';
import { InvoiceType } from '../../../propTypes';

const LazyFolioCell = ({
  lazyCellProps,
  folioCellProps,
}) => (
  <LazyCell
    key={`${lazyCellProps.rowId}`}
    queryKey={lazyCellProps.queryKey}
    queryName={lazyCellProps.queryName}
    additionalQueriesResults={lazyCellProps.additionalQueriesResults}
    rowId={lazyCellProps.rowId}
    showPartialResult={lazyCellProps.showPartialResult}
    renderContent={(matchingEdge) => (
      <FolioCell
        invoice={mergeInvoiceDocumentFinanceState(
          folioCellProps.invoice,
          matchingEdge?.node,
        )}
        alignCenter={folioCellProps.alignCenter}
        maxLength={folioCellProps.maxLength}
      />
    )}
  />
);

LazyFolioCell.propTypes = {
  lazyCellProps: PropTypes.shape({
    rowId: PropTypes.string.isRequired,
    queryKey: PropTypes.string.isRequired,
    queryName: PropTypes.string.isRequired,
    additionalQueriesResults: PropTypes.shape({}),
    showPartialResult: PropTypes.bool,
  }).isRequired,
  folioCellProps: PropTypes.shape({
    invoice: InvoiceType.isRequired,
    alignCenter: PropTypes.bool,
    maxLength: PropTypes.number,
  }).isRequired,
};

export default LazyFolioCell;
